"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = exports.Actions = void 0;
const styles_1 = require("@mui/material/styles");
exports.Actions = (0, styles_1.styled)("div")({
    marginTop: "auto",
    fontSize: "1rem",
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-end"
});
exports.Divider = (0, styles_1.styled)("div")(({ theme }) => ({
    backgroundColor: theme.colours.storm,
    height: "32px",
    width: "1px"
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2RvY3VtZW50LWNhcmQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUVqQyxRQUFBLE9BQU8sR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUNuQyxTQUFTLEVBQUUsTUFBTTtJQUNqQixRQUFRLEVBQUUsTUFBTTtJQUNoQixVQUFVLEVBQUUsUUFBUTtJQUNwQixPQUFPLEVBQUUsTUFBTTtJQUNmLGNBQWMsRUFBRSxVQUFVO0NBQzNCLENBQUMsQ0FBQztBQUVVLFFBQUEsT0FBTyxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNuRCxlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0lBQ3BDLE1BQU0sRUFBRSxNQUFNO0lBQ2QsS0FBSyxFQUFFLEtBQUs7Q0FDYixDQUFDLENBQUMsQ0FBQyJ9